import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Image,
  Link,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuToggle,
} from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import MomoKarmaIcon from "../Icons/AppIcons/MomoKarmaIcon.svg";
import AppKarmaIcon from '../Icons/AppIcons/AppKarmaIcon.svg'
import CashKarmaIcon from '../Icons/AppIcons/CashKarmaIcon.svg'
import { useNavigate } from 'react-router-dom'

export default function NavbarComponent({ selectedPage, setSelectedPage, appRef }) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const menuItems = [
    // {
    //   value: 'About',
    //   key: '/#landing_page',
    // },
    // {
    //   value: 'About',
    //   key: '#about_page',
    // },
    {
      value: 'Affiliate Program',
      key: '/#affiliate_program_page',
    },
    {
      value: 'Contact',
      key: '/#contact_page',
    },
  ]

  /**
   * Add Your Apps
   */
  const AppArray = [
    {
      key: 'AppKarma',
      label: 'AppKarma',
      icon: <Image src={AppKarmaIcon} width={'24'} height={'24'} />,
      ref: appRef[0],
      route: '/#appkarma_page'
    },
    {
      key: 'CashKarma',
      label: 'CashKarma',
      icon: <Image src={CashKarmaIcon} width={'24'} height={'24'} />,
      ref: appRef[1],
      route: '/#cashkarma_page'
    },
  ]

  const handleScrollToSection = (ref) => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {

  }, [isMenuOpen])

  return (
    <Navbar
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      className="lg:px-8 px-0 text-black py-2 bg-transparent lg:container mx-auto"
      maxWidth={'full'}
    >
      <NavbarContent>
        <NavbarMenuToggle
          aria-label={!isMenuOpen ? 'Close menu' : 'Open menu'}
          className="sm:hidden"
        />
        <NavbarBrand className="">
          <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="flex items-center gap-2">
            <div className=""><Image src={MomoKarmaIcon} width={'36'} height={'36'} /></div> <div className='font-bold text-xl' style={{ fontFamily: 'Mulish' }}>MomoKarma</div>
            </div>
          </a>
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent
        className="hidden sm:flex text-black"
        justify="center"
      >
        {menuItems.map((item, key) => (
          <NavbarItem
            key={key}
            isActive={selectedPage === item.key}
            className="text-black"
          >
            {item.value === 'Contact' ? (
              <Button
                className='text-[#212121] bg-transparent hover:bg-[#EEEEEE] rounded-full font-plus-jakarta font-normal'
                as="a"
                href="mailto:support@mail.momokarma.com"
              >
                {item.value}
              </Button>
            ) : (
              <Button
                className='text-[#212121] bg-transparent hover:bg-[#EEEEEE] rounded-full font-plus-jakarta font-normal'
                onClick={() => {
                  setSelectedPage(item.key)
                  navigate(item.key)
                }}
              >
                {item.value}
              </Button>
            )}
          </NavbarItem>
        ))}
      </NavbarContent>
      <NavbarContent justify="end">
        <NavbarItem className="flex">
          <Dropdown onOpenChange={() => setIsDropdownOpen((pre) => !pre)}>
            <DropdownTrigger>
              <Button className="rounded-full bg-[#147AFF]">
                <div className="flex gap-2 items-center">
                  <div className="text-white" style={{ fontFamily: 'Mulish' }}>Our Apps</div>{' '}
                  <div className="text-white pt-[1px]">
                    {isDropdownOpen ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m4.5 15.75 7.5-7.5 7.5 7.5"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m19.5 8.25-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Dynamic Actions" items={AppArray}>
              {(item) => (
                <DropdownItem 
                  key={item.key} 
                  onClick={() => navigate(item.route)}
                >
                  <div className="flex items-center">
                    <div>{item.icon}</div>{' '}
                    <div className="ms-3" style={{ fontFamily: 'Mulish', color: '#212121', fontSize: '16px' }}>{item.label}</div>
                  </div>
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        </NavbarItem>
      </NavbarContent>
      <NavbarMenu className="">
        {menuItems.map((item, index) => (
          <NavbarMenuItem key={`${item.key}-${index}`} isActive={item.key === selectedPage}>
            {item.value === 'Contact' ? (
              <Link className="mt-4 w-full pt-4 text-[#888888] font-plus-jakarta font-normal" href="mailto:support@mail.momokarma.com" size="lg" onClick={() => setIsMenuOpen(pre => !pre)}>
                {item.value}
              </Link>
            ) : (
              <Link className="mt-4 w-full pt-4 text-[#888888] font-plus-jakarta font-normal" href={`${item.key}`} size="lg" onClick={() => setIsMenuOpen(pre => !pre)}>
                {item.value}
              </Link>
            )}
          </NavbarMenuItem>
        ))}
      </NavbarMenu>
    </Navbar>
  )
}
